import { makeStyles, Theme } from '@material-ui/core';

export const useTokenStyles = makeStyles<Theme>((theme) => ({
  tokenWrapper: {
    display: 'flex',
    flexDirection: 'column',
    aligIitems: 'flex-start',
    gap: '8px',
    alignSelf: 'stretch',
    [theme.breakpoints.down('md')]: {},
    [theme.breakpoints.down('sm')]: {},
  },
  tokenHeader: {
    display: 'grid',
    alignItems: 'center',
    // gridTemplateColumns: '25% 25% 30% 20%',
    gridTemplateColumns: '35% 35% 30%',
    color: '#949494',
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: '26px',
    [theme.breakpoints.down('sm')]: {},
    [theme.breakpoints.down('xs')]: {
      display: 'none',
    },

    '& > span': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      flex: 1,
    },
    '& > span:last-child': {
      justifySelf: 'flex-end',
    },
  },
  tableRow: {
    display: 'grid',
    alignItems: 'center',
    gridTemplateColumns: '35% 35% 30%',
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: '20px',
    color: '#FAFAFA',
    padding: '18px 0',
    minHeight: '86px',
    borderBottom: '1px solid #323235',

    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
      rowGap: '8px',
    },
    [theme.breakpoints.down('xs')]: {},
  },
  token: {
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
    [theme.breakpoints.down('sm')]: {
      gap: '6px',
    },
  },
  rowTableIcon: {
    background: '#43464D',
    width: '36px',
    height: '36px',
    borderRadius: '18px',
    padding: '7px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexShrink: 0,
  },
  itemRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  gap8: {
    gap: '8px',
  },
  itemActions: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: '8px',
    [theme.breakpoints.down('xs')]: {
      flexBasis: '100%',
      gap: '16px',
      justifyContent: 'space-between',
    },
  },
  itemColumn: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
  title: {
    color: '#FAFAFA',
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: '20px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '13px',
    },
  },
  value: {
    color: '#949494',
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: '20px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '13px',
    },
  },
  targetIcon: {
    color: '#FAFAFA',
  },
  noDataWrapper: {
    width: '100%',
    maxWidth: '384px',
    margin: '0 auto',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  buttonIcon: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
}));
